export enum ELoadingStatus {
  Initial = 'initial',
  Loading = 'loading',
  Success = 'success',
  Failure = 'failure',
}

export type TLoadingStatus = {
  requestStatus: ELoadingStatus;
  pageLoader: boolean;
};
